export default __webpack_public_path__ + "50b95659ec47cb3cb5222d929c4a2348.svg";